<template>
  <div class="lightList-content" v-loading="loading">
    <div class="head_body">
      <el-form ref="form" :model="pageInfo" class="search_head">
        <el-row :gutter="20" class="list-head">
          <el-col :span="4">
            <el-form-item label="设备号">
              <el-input v-model="pageInfo.lamp_number" placeholder="请输入设备识别号" clearable/>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="名称">
              <el-input v-model="pageInfo.lamp_name" placeholder="请输入设备名称" clearable/>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="分组">
              <el-select
                clearable
                placeholder="请选择分灯组"
                v-model="pageInfo.lamp_group"
                style="width: 100%"
              >
                <el-option
                  v-for="t in groupListSearch"
                  :key="t.id"
                  :label="t.name"
                  :value="t.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="策略">
              <el-select
                placeholder="选择策略"
                v-model="pageInfo.ms"
                style="width: 100%"
                clearable
              >
                <el-option
                  v-for="t in strategyType"
                  :key="t.id"
                  :label="t.name"
                  :value="t.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="状态">
              <el-select
                clearable
                placeholder="选择状态"
                v-model="pageInfo.ste"
                style="width: 100%"
              >
                <el-option
                  v-for="t in stateList"
                  :key="t.id"
                  :label="t.name"
                  :value="t.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="2" :offset="2" class="search-btn-box">
              <el-button type="primary" size="small" @click="headSearch"><svg-icon name="search"></svg-icon>搜索</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="h20"></div>
    <div class="con-body">
      <div class="control-group">
        <div class="group-left">
          <el-button
            type="primary"
            size="small"
            @click="openEditWin('create')"
            class="insert-btn"
            ><svg-icon name="add-plus"></svg-icon>添加</el-button
          >
          <el-button
            type="primary"
            size="small"
            @click="importLamp()"
            class="insert-btn"
            ><svg-icon name="import"></svg-icon>批量导入</el-button
          >
        </div>
        <div class="group-right">
          <el-button
            type="primary"
            size="small"
            @click="recoveryAll(0)"
            >恢复策略</el-button
          >
          <el-button
            type="primary"
            size="small"
            @click="lightContorls('close')"
            >一键关灯</el-button
          >
          <el-button
            type="primary"
            size="small"
            @click="lightContorls('open')"
            >一键开灯</el-button
          >
        </div>
      </div>
      <el-table 
        :data="tableData"
        style="width: 100%"
        ref="table"
        :row-key="getRowKey"
        @selection-change="handleSelectionChange"
        >
        <el-table-column
          type="selection"
          :selectable="checkNoSelect"
          :reserve-selection="true"
          width="80">
        </el-table-column>
        <el-table-column
          prop="number"
          label="设备识别号"
          width="180"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="name"
          label="设备别名"
          width="180"
          align="center"
          stripe
        ></el-table-column>
        <el-table-column
          label="开关状态"
          prop="lights_status"
          width="150"
          align="center"
          sortable
        >
          <template slot-scope="scope">
            <i :class="lightStatusColor[scope.row.lights_status]"></i>
            <span>{{ lightStatus[scope.row.lights_status] }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="路灯类型"
          prop="is_double"
          align="center"
          width="130"
        >
          <template slot-scope="scope">
            {{ doubleType[scope.row.is_double] }}
          </template>
        </el-table-column>
        <el-table-column
          prop="brightness"
          label="亮度"
          align="center"
          width="130"
        ></el-table-column>
        <el-table-column
          label="在线状态"
          prop="ste"
          width="150"
          align="center"
          sortable
        >
          <template slot-scope="scope">
            <i :class="steColorType[scope.row.ste]"></i>
            <span>{{ steType[scope.row.ste] }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="分组"
          prop="group_name"
          width="150"
          align="center"
        ></el-table-column>
        <el-table-column
          label="当前策略"
          align="center"
          width="160"
        >
          <template slot-scope="scope">
            <template v-if="scope.row.ms==0">
              <span v-if="scope.row.group_stg_id">{{ scope.row.group_stg_name }}<br/>(分组策略)</span>
              <span v-else-if="scope.row.stg_id">{{ scope.row.stg_name }}<br/>(本灯策略)</span>
              <span v-else>暂无策略</span>
            </template>
            <template v-else>
              <span>手动操作</span>
            </template>
          </template>
        </el-table-column>
        <el-table-column
          label="控制模式"
          align="center"
          width="150"
        >
          <template slot-scope="scope">
            <template v-if="scope.row.ms==0">
              <span v-if="scope.row.group_stg_id||scope.row.stg_id">自动模式</span>
              <span v-else>暂无</span>
            </template>
            <template v-else>
              <span>手动模式</span>
            </template>
          </template>
        </el-table-column>
        <el-table-column
          prop="current"
          label="电流(A)"
          width="130"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="voltage"
          label="电压(V)"
          width="130"
          align="center"
        ></el-table-column>
        
        <el-table-column
          v-if="$store.state.user.name=='smile03'||$store.state.user.name=='simle03'"
          prop="loadCondition"
          label="负载情况"
          width="120"
          align="center"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.loadCondition==1||scope.row.loadCondition=='1'">
              正常
            </div>
            <div v-else style="color: red;">
              {{ loadConditionArr[scope.row.loadCondition] }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          v-if="$store.state.user.name=='smile03'||$store.state.user.name=='simle03'"
          label="电能情况"
          width="120"
          align="center"
        >
          <template slot-scope="scope">
            <div class="power-more" @click="showPower(scope.row.lamp_id)"></div>
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="freq"
          label="信号强度"
          width="120"
          align="center"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.freq.level>-1" class="freq-box" @click="showFreq(scope.row.freq)">
              <div :class="'freq-icon icon'+scope.row.freq.level">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
              </div>
              <div :class="'freq-value value'+scope.row.freq.level">{{ freq.levelArr[scope.row.freq.level] }}</div>
            </div>
            <div v-else-if="scope.row.freq.level==-1||scope.row.freq.level=='-1'">
              -
            </div>
            <div v-else @click="showFreq(scope.row.freq)">
              未知
            </div>
          </template>
        </el-table-column> -->
        <el-table-column
          prop="imsi"
          label="IMSI"
          width="130"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="imei"
          label="IMEI"
          width="130"
          align="center"
        ></el-table-column>
        <el-table-column prop="edit" label="操作" fixed="right" width="220">
          <template slot-scope="scope">
            <div class="table-last">
              <template v-if="scope.row.ste">
                <span v-if="scope.row.ms" @click="recoveryWin(scope.row)" class="blue pointer mar-r10">恢复策略</span>
                <span else class="blue pointer mar-r10">　　　　</span>
              </template>
              <template v-else>
                <span @click="viewReason(scope.row.last_ping)" class="blue pointer mar-r10">查看原因</span>
              </template>
              <span @click="openEditWin(scope.row)" class="blue pointer mar-r10">编辑</span>
              <span @click="delItem(scope.row.lamp_id)" class="blue pointer">删除</span>
            </div>
          </template>
        </el-table-column>

      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageInfo.page"
        :page-sizes="[10, 20, 30, 40, 50, 100, 200, 300, 500, 1000, 1500, 2000]"
        :page-size="pageInfo.pageSize"
        layout="sizes, total, prev, pager, next, jumper"
        :total="cnt_all"
      >
      </el-pagination>
    </div>
    <!-- 编辑设备信息弹窗 -->
    <el-dialog
      class="dialog860"
      :title="editType === 'create' ? '添加设备' : '修改设备'"
      :visible.sync="dialogVisible">
      <el-form
        :model="editOne"
        class="form-info"
        :rules="editOneRule"
        ref="lampInfo"
      >
        <el-row :gutter="20" class="item-list">
          <el-col :span="12">
            <el-form-item label="设备编号" prop="number">
              <el-input v-model="editOne.number" placeholder="请输入设备编号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="设备别名" prop="name">
              <el-input v-model="editOne.name" placeholder="请输入设备别名"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="选择协议" prop="lamp_type">
              <el-select
                clearable
                placeholder="请选择路灯协议"
                v-model="editOne.lamp_type"
                style="width: 100%"
              >
                <el-option
                  v-for="t in protocolList"
                  :key="parseInt(t.id)"
                  :label="t.name"
                  :value="parseInt(t.id)"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col v-if="editOne.lamp_type==5" :span="12">
            <el-form-item label="灯头号" prop="light_pole">
              <el-input v-model="editOne.light_pole" placeholder="请输入灯头号"></el-input>
            </el-form-item>
          </el-col>

          <el-col v-if="editOne.lamp_type==3||editOne.lamp_type==5" :span="12">
            <el-form-item label="网关编号" prop="gateway">
              <el-input v-model="editOne.gateway" placeholder="请输入网关编号"></el-input>
            </el-form-item>
          </el-col>
          
          <el-col :span="12">
            <el-form-item label="路灯模式" prop="is_double">
              <el-select
                placeholder="请选择单、双灯"
                v-model="editOne.is_double"
                style="width: 100%"
                @change="getStrategyList('clear');getGroupList()"
              >
                <el-option
                  v-for="(t,index) in doubleType"
                  :key="index"
                  :label="t"
                  :value="index"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="路灯分组">
              <el-select
                placeholder="请选择路灯分组"
                v-model="editOne.lamp_group"
                style="width: 100%"
              >
                <el-option
                  v-for="t in groupList"
                  :key="t.id"
                  :label="t.name"
                  :value="t.id"
                ></el-option>
                <el-option :key="0" label="暂无分组" :value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="电流模式" prop="lamp_ctrl_type">
              <el-select
                placeholder="请选择电流模式"
                v-model="editOne.lamp_ctrl_type"
                style="width: 100%"
              >
                <el-option
                  v-for="(t,index) in lampCtrlType"
                  :key="index"
                  :label="t"
                  :value="index"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="路灯策略">
              <el-select
                placeholder="请选择路灯策略"
                v-model="editOne.stg_id"
                style="width: 100%"
              >
                <el-option
                  v-for="t in strategyList"
                  :key="t.id"
                  :label="t.title"
                  :value="t.id"
                ></el-option>
                <el-option :key="0" label="暂无策略" :value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <div class="col-two">
              <div class="col-one">
                <div class="checkbox-item">
                  <el-checkbox v-model="editOne.is_area_strategy" :disabled="areaStrategyList.length
                  ?false:true">是否叠加区域策略</el-checkbox>
                </div>
              </div>
            </div>
          </el-col>

          <el-col :span="12">
            <el-form-item label="SIM卡号">
              <el-input v-model="editOne.sim"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="路灯地址" prop="address">
              <el-input v-model="editOne.address" class="address" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="经纬度" class="lnglat-input">
              <el-input v-model="editOne.longitude" @input="onInput()"></el-input>
              <el-input v-model="editOne.latitude" @input="onInput()"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <div class="map-box">
              <amap :nowlng="editOne.longitude" :nowlat="editOne.latitude" @mapDing="getCoordinate" />
            </div>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="checkbox-item">
              <el-checkbox v-model="editOne.is_display" :true-label="1" :false-label="0">首页显示</el-checkbox>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="box-footer">
              <el-button
                size="medium"
                class="cancel-btn"
                @click="dialogVisible = false"
                >取消</el-button >
  
              <el-button
                type="primary"
                size="medium"
                @click="createItem"
                v-if="editType === 'create'"
                >确定提交</el-button>
              <el-button
                type="primary"
                size="medium"
                @click="updateItem"
                v-if="editType === 'update'"
                >确定提交</el-button>
            </div>
            
          </el-col>
        </el-row>
      </div>
    </el-dialog>

    <!-- 电能情况说明 -->
    <el-dialog class="dialog600" title="电能情况" :visible.sync="power.visible">
      <div class="box_body">
        <el-table :data="power.data" style="width: 100%" stripe border class="dialog">
          <el-table-column
            prop="name"
            label="名称"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="level"
            label="数值"
            align="center"
          >
            <template slot-scope="scope">
              {{scope.row.value}}{{scope.row.unit}}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="power.visible=false" size="small"
          >好的</el-button
        >
      </div>
    </el-dialog>

    <!-- 信号强度说明 -->
    <el-dialog class="dialog600" title="信号强度说明" :visible.sync="freq.visible">
      <div class="box_body">
        <el-table :data="freq.data" style="width: 100%" stripe border class="dialog">
          <el-table-column
            prop="value"
            label="数值（整型）"
            width="160"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="level"
            label="级别"
            width="160"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="detail"
            label="说明"
            align="center"
            stripe
          ></el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="freq.visible=false" size="small"
          >好的</el-button
        >
      </div>
    </el-dialog>


    <!-- 一键开关灯ws -->
    <div
      v-if="lightContorl.visible"
      class="box_control_bg ws-control"
      :class="lightContorl.open?'pack-up':''"
    ></div>
    <div v-if="lightContorl.visible" class="right-control-btn" :class="lightContorl.open?'pack-up':''" @click="lightContorl.open=false">
      <div class="icon"><svg-icon name="lamp-open"/></div>
      <span v-if="lightContorl.cmdState==1" class="blue">执行中...</span>
      <span v-else-if="lightContorl.cmdState==2" class="blue">部分完成</span>
      <span v-else-if="lightContorl.cmdState==3" class="green">已完成</span>
      <span v-else-if="lightContorl.cmdState==4" class="red">执行失败</span>
    </div>
    <div v-if="lightContorl.visible" class="box_control lamp-control" :class="lightContorl.open?'pack-up':''">
      
      <div class="box_body">
        <div class="box_con">
          <div class="box_title">手动策略　|　一键{{ lightContorl.openControl=='open'?'开灯':'关灯' }}</div>

          <div v-if="lightContorl.cmdState==1" class="right-close" @click="lightContorl.open=true"><svg-icon name="retract"/></div>
          <div v-else class="right-close" @click="lightContorlClose"><i class="el-icon-close"></i></div>

          <!-- cmdState:  0.未发送执行  1.已发送命令  2.部分完成  3.已完成 4.失败  -->
          <div v-if="lightContorl.cmdState==0" class="lamp-control-tip">{{lightContorl.title}} (亮度{{lightContorl.light}}%) ?</div>
          <div v-else-if="lightContorl.cmdState==1" class="lamp-control-tip">平台命令下发成功，等待设备执行命令...</div>
          <div v-else-if="lightContorl.cmdState==2" class="lamp-control-tip">平台命令下发成功，部分设备执行命令完成。</div>
          <div v-else-if="lightContorl.cmdState==3" class="lamp-control-tip">平台命令下发成功，所有设备执行命令完成。</div>
          <div v-else-if="lightContorl.cmdState==4" class="lamp-control-tip">平台命令下发成功，设备执行失败。</div>
          
          <div class="lamp-control-list">
            <div class="item-one" v-for="(item,index) in multipleSelection" :key="index">
              <div class="item-one-pad">
                <div class="item-icon"><svg-icon :name="lightContorl.openControl=='open'?'lamp-close':'lamp-open'"/></div>
                <div class="item-title">{{item.name}}</div>
                <div v-if="lightContorl.cmdState" class="item-cmd">
                  <span v-if="item.flag==1" class="green">执行成功</span>
                  <span v-else-if="item.flag==0" class="red">执行失败</span>
                  <span v-else class="blue">执行中...</span>
                </div>
                <div v-else class="item-close" @click="removeControlLamp(index)"><svg-icon name="close-round"/></div>
              </div>
            </div>
          </div>

          <!-- double_exist: 1, // 1都是单灯, 2都是双灯, 3存在单、双灯 -->
          <template v-if="lightContorl.openControl=='open'&&lightContorl.cmdState==0">
            <div class="lamp-control-silder">
              <div class="silder-title">{{ lightContorl.double_exist==1?'亮度调节':'亮度调节一' }}</div>
              <div class="silder-box">
                <el-slider
                  :disabled="lightContorl.cmdState?true:false"
                  v-model="lightContorl.light"
                  :min="0"
                  :max="100"
                  @change="manualChange = true"
                  class="lamp-silder"
                ></el-slider>
                <div class="silder-value">{{lightContorl.light}}%</div>
              </div>
            </div>

            <div v-if="lightContorl.double_exist==3" class="lamp-tips">（提示:所选单灯为第一个调光轴）</div>
            <div v-if="lightContorl.double_exist!=1" class="lamp-control-silder">
              <div class="silder-title">亮度调节二</div>
              <div class="silder-box">
                <el-slider
                  :disabled="lightContorl.cmdState?true:false"
                  v-model="lightContorl.light2"
                  :min="0"
                  :max="100"
                  class="lamp-silder"
                ></el-slider>
                <div class="silder-value">{{lightContorl.light2}}%</div>
              </div>
            </div>
          </template>

          <div v-if="lightContorl.cmdState==1" class="box-tips">
            <div class="tips-icon"><i class="el-icon-warning"></i>提醒：</div>
            该过程最多需要两分钟，可以点击右上角收起状态栏
          </div>

          <div v-else-if="lightContorl.cmdState==2" class="box-tips">
            <div class="tips-icon"><i class="el-icon-warning"></i>执行结果：</div>
            设备已{{ lightContorl.openControl=='open'?'开灯':'关灯' }}成功 <span class="green">{{controlResultCount(1)}}</span>个，{{ lightContorl.openControl=='open'?'开灯':'关灯' }}失败<span class="red">{{controlResultCount(0)}}</span>个。是否对{{ lightContorl.openControl=='open'?'开灯':'关灯' }}失败的设备继续下发？
          </div>

          <div v-else-if="lightContorl.cmdState==3" class="box-tips">
            <div class="tips-icon"><i class="el-icon-warning"></i>执行结果：</div>
            设备已{{ lightContorl.openControl=='open'?'开灯':'关灯' }}成功 <span class="green">{{multipleSelection.length}}</span>个，{{ lightContorl.openControl=='open'?'开灯':'关灯' }}失败0个。执行成功的设备若要执行<span class="blue">自动策略</span>,请在路灯列表中选择<span class="blue">恢复策略</span>
          </div>
          <div v-else-if="lightContorl.cmdState==4" class="box-tips">
            <div class="tips-icon"><i class="el-icon-warning"></i>执行结果：</div>
            服务拥塞、或者网络问题命令下发及执行失败，建议您稍后重新下发！
          </div>

        </div>

        <!-- cmdState:  0.未发送执行  1.已发送命令  2.部分完成  3.已完成 4.失败  -->
        <div v-if="lightContorl.cmdState==0" class="box-footer">
          <el-button @click="lightContorlClose" class="cancel-btn" size="medium">关 闭</el-button>
          <el-button type="primary" @click="lightContorlSend()" size="medium">立即执行</el-button>
        </div>

        <div v-if="lightContorl.cmdState==2" class="box-footer">
          <el-button type="primary" @click="lightContorlClose" size="medium">完成</el-button>
          <el-button type="primary" @click="lightContorlSend()" size="medium">二次下发</el-button>
        </div>


        <div v-if="lightContorl.cmdState==3" class="box-footer">
          <el-button type="primary" @click="lightContorlClose" size="medium">执行完成</el-button>
        </div>

        <!-- 服务拥塞、或者网络问题命令下发及执行失败 -->
        <div v-if="lightContorl.cmdState==4" class="box-footer">
          <el-button @click="lightContorlClose" class="cancel-btn" size="medium">关 闭</el-button>
          <el-button type="primary" @click="lightContorlSend()" size="medium">重新下发</el-button>
        </div>

      </div>
    </div>
    <!-- 批量导入 -->
    <el-dialog v-if="importFile.visible" class="dialog750" title="批量导入" :visible.sync="importFile.visible">
      <div class="import_box">
        <div class="import_tip">
          <div class="tip_text">1、请点击上传按钮选择需要上传的文件。</div>
          <div class="tip_text">2、每次只能上传单个文件，单次文件大小不能超过2M，文件格式为*.xls格式。</div>
          <div class="tip_foot">
            <div class="tip_icon"><i class="el-icon-warning"></i></div>
            <div class="item">需要上传文件的格式和规范以模板为准，为了您的方便，请尽量下载模板填写内容。</div>
          </div>
        </div>

        <el-upload
          class="upload-import-box"
          :class="importFile.file?'have':''"
          ref="uploadImportFile"
          name="file"
          :action="uploadAction()"
          :limit="1"
          :file-list="importFile.fileList"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeUpload"
        >
          <el-button slot="trigger" size="medium" type="primary" class="select-btn">选择文件</el-button>
        </el-upload>
        <el-button class="cancel-btn" :class="importFile.file?'have':''" @click="importFile.visible = false" size="medium">取 消</el-button>
        <el-button v-if="importFile.file" class="start-btn" type="primary" @click="importSend" size="medium">开始导入</el-button>
        <div class="demo_xls">
          <svg-icon name="files"></svg-icon>
          <a class="xls-link" href="https://light.taiott.com/static/upload/xlsx/模板.xlsx" target="_blank">下载模版文件</a>
        </div>
      </div>
    </el-dialog>

    <el-dialog class="dialog360" title="文件导入中" :visible.sync="importFile.state == 1" append-to-body>
      <div class="icon_box"><i class="el-icon-loading"></i></div>
    </el-dialog>

    <!-- 恢复策略 -->
    <el-dialog v-if="recoveryVisible" class="dialog750" title="恢复策略" :visible.sync="recoveryVisible">

      <!-- 路灯存在分组 -->
      <template v-if="recoveryData.lamp_group">
        <!-- 分组策略存在 -->
        <template v-if="recoveryData.group_stg_id">
          <!-- 分组手动模式 -->
          <div v-if="recoveryData.group_ms">
            <div class="recovery-Stategy-box">
              <div class="item">您的路灯目前是手动模式{{ lightStatus[recoveryData.lights_status] }}，该路灯在[{{ recoveryData.group_name }}]下，该分组为手动模式，请到分组中恢复策略。</div>
              <div class="item">
                <div class="stategy_name">{{recoveryData.group_stg_name}}(分组策略)</div>
                <div class="stategy_mod" @click="golampGroup()">去分组中恢复策略 >></div>
              </div>
            </div>
            <div slot="footer" class="dialog-footer">
              <div class="box-footer lamp-recovery-footer">
                <el-button class="cancel-btn" size="medium" @click="recoveryVisible=false">取消</el-button>
                <el-button :disabled="true" type="primary" size="medium">确定</el-button>
              </div>
            </div>
          </div> 
          <!-- 分组自动模式 -->
          <div v-else> 
            <div class="recovery-Stategy-box"> 
              <div class="item">您的路灯目前是手动模式{{ lightStatus[recoveryData.lights_status] }}，该路灯在[{{ recoveryData.group_name }}]下，该分组为自动模式，您是否恢复如下分组策略定时开关灯?</div>
              <div class="item">
                <div class="stategy_name">{{recoveryData.group_stg_name}}(分组策略)</div>
                <div class="stategy_mod">点击右下角“确定”按钮即可恢复分组策略！</div>
              </div>
            </div>
            <div slot="footer" class="dialog-footer">
              <div class="box-footer lamp-recovery-footer">
                <el-button class="cancel-btn" size="medium" @click="recoveryVisible=false">取消</el-button>
                <el-button type="primary" size="medium" @click="setRecoveryStrategy(recoveryData.lamp_id)">确定</el-button>
              </div>
            </div>
          </div>
        </template>
        <!-- 分组策略不存在,本路灯存在策略 -->
        <div v-else-if="recoveryData.stg_id">
          <div class="recovery-Stategy-box">
            <div class="item">您的路灯目前是手模式{{ lightStatus[recoveryData.lights_status] }}，您是否恢复如下定时开关灯策略?</div>
            <div class="item item2">
              <!-- 可下拉改 -->
              <div class="name-select">
                <el-select
                  placeholder="请选择路灯策略"
                  v-model="recoveryData.new_stg_id"
                  style="width: 100%"
                >
                  <el-option
                    v-for="t in recoveryStrategyList"
                    :key="t.id"
                    :label="t.title"
                    :value="t.id"
                  ></el-option>
                  <el-option :key="0" label="暂无策略" :value="0"></el-option>
                </el-select>
              </div>(本灯策略)
              <div class="stategy_tip"> &lt;&lt; 请选择您要恢复的策略！</div>
            </div>
          </div>
          <div slot="footer" class="dialog-footer">
            <div class="box-footer lamp-recovery-footer">
              <el-button class="cancel-btn" size="medium" @click="recoveryVisible=false">取消</el-button>
              <el-button type="primary" size="medium" @click="setRecoveryStrategy(recoveryData.lamp_id)">确定</el-button>
            </div>
          </div>
        </div>

        <!-- 分组不存在策略,本路灯不存在策略 -->
        <div v-else>
          <div class="recovery-Stategy-box">
            <div class="item">您的路灯目前是手动模式{{ lightStatus[recoveryData.lights_status] }}，该路灯分组不存在策略,路灯本身也无策略。</div>
            <div class="item item2">
              <!-- 可下拉改 -->
              <div class="name-select">
                <el-select
                  placeholder="请选择路灯策略"
                  v-model="recoveryData.new_stg_id"
                  style="width: 100%"
                >
                  <el-option
                    v-for="t in recoveryStrategyList"
                    :key="t.id"
                    :label="t.title"
                    :value="t.id"
                  ></el-option>
                  <el-option :key="0" label="暂无策略" :value="0"></el-option>
                </el-select>
              </div>(本灯策略)
              <div class="stategy_tip"> &lt;&lt; 请给该路灯选择策略！</div>
            </div>
            
          </div>
          <div slot="footer" class="dialog-footer">
            <div class="box-footer lamp-recovery-footer">
              <el-button class="cancel-btn" size="medium" @click="recoveryVisible=false">取消</el-button>
              <el-button type="primary" size="medium" @click="setRecoveryStrategy(recoveryData.lamp_id)">确定</el-button>
            </div>
          </div>
        </div>
      </template>

      <template v-else>
        <!-- 不存在分组,本路灯存在策略 -->
        <div v-if="recoveryData.stg_id">
          <div class="recovery-Stategy-box">
            <div class="item">您的路灯目前是{{ msType[recoveryData.ms] }}{{ lightStatus[recoveryData.lights_status] }}，您是否恢复如下定时开关灯策略?</div>
            <!-- 可下拉改 -->
            <div class="item item2">
              <div class="name-select">
                <el-select
                  placeholder="请选择路灯策略"
                  v-model="recoveryData.new_stg_id"
                  style="width: 100%"
                >
                  <el-option
                    v-for="t in recoveryStrategyList"
                    :key="t.id"
                    :label="t.title"
                    :value="t.id"
                  ></el-option>
                  <el-option :key="0" label="暂无策略" :value="0"></el-option>
                </el-select>
              </div>(本灯策略)
              <div class="stategy_tip"> &lt;&lt; 请选择您要恢复的策略！</div>
            </div>
          </div>
          <div slot="footer" class="dialog-footer">
            <div class="box-footer lamp-recovery-footer">
              <el-button class="cancel-btn" size="medium" @click="recoveryVisible=false">取消</el-button>
              <el-button type="primary" size="medium" @click="setRecoveryStrategy(recoveryData.lamp_id)">确定</el-button>
            </div>
          </div>
        </div>

        <!-- 不存在分组,本路灯不存在策略 -->
        <div v-else>
          <div class="recovery-Stategy-box">
            <div class="item">您的路灯目前是{{ msType[recoveryData.ms] }}{{ lightStatus[recoveryData.lights_status] }}，该路灯无分组也无策略。</div>
            <div class="item">
              <!-- 可下拉改 -->
              <div class="name-select">
                <el-select
                  placeholder="请选择路灯策略"
                  v-model="recoveryData.new_stg_id"
                  style="width: 100%"
                >
                  <el-option
                    v-for="t in recoveryStrategyList"
                    :key="t.id"
                    :label="t.title"
                    :value="t.id"
                  ></el-option>
                  <el-option :key="0" label="暂无策略" :value="0"></el-option>
                </el-select>
              </div>(本灯策略)
              <div class="stategy_tip"> &lt;&lt; 请给该路灯选择策略！</div>
            </div>
          </div>
          <div slot="footer" class="dialog-footer">
            <div class="box-footer lamp-recovery-footer">
              <el-button class="cancel-btn" size="medium" @click="recoveryVisible=false">取消</el-button>
              <el-button type="primary" size="medium" @click="setRecoveryStrategy(recoveryData.lamp_id)">确定</el-button>
            </div>
          </div>
        </div>
      </template>
    </el-dialog>
    
    <!-- 查看原因 -->
    <div
      class="box_control_bg"
      v-if="reasonData.visible"
      @click="reasonData.visible=false"
    ></div>
    <div v-if="reasonData.visible" class="box_control reason-box">
      <div class="box_body">
        <div class="box_con">
          <div class="box_title"><i class="el-icon-message-solid"></i><span>查看离线原因</span></div>
          <div class="con-text">
            <div class="item-title">请您先自检如下操作:</div>
            <div class="item">1）该设备是否接入电源<br/>2）天线是否接入，信号是否正常</div>
            <div class="item-heart" v-if="reasonData.last_ping">该设备最后一次心跳时间为: {{reasonData.last_ping}}</div>
            <div class="item-heart" v-else>该设备最后一次心跳时间为: 无</div>
            <div class="item-title">平台建议:</div>
            <div class="item">由于最后一次心跳时间距现在较短，平台对在线条件校验严格，建议您观察1天后，再联系销售经理</div>
          </div>
        </div>
        <div class="box-footer">
          <el-button type="primary" @click="reasonData.visible=false" size="medium">知道了</el-button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import lightListApi from "@/api/light/lightList"
import strategyApi from "@/api/light/strategy"
import lightGroupApi from "@/api/light/lampGroup"
import store from '@/store'
import amap from '@/components/addMap'
import { getToken } from '@/utils/auth'
export default {
  components: {
    amap
  },
  data() {
    return {
      loading: false,
      protocolList: [],
      strategyList: [],
      areaStrategyList: [],
      groupList: [],
      groupListSearch: [],
      doubleType: ["单灯", "双灯"],
      loadConditionArr: ["", "正常", "过压", "过载", "过流"],
      lampCtrlType: ["单电流", "双电流"],
      steType: ["离线", "在线"],
      stateList:[
        {
          id: 0,
          name:"离线"
        },{
          id: 1,
          name:"在线"
        }
      ],
      strategyType: [
        {
          id: 0,
          name: '自动策略',
        },
        {
          id: 1,
          name: '手动策略',
        }
      ],
      steColorType: ["valuegrey", "valuegreen"],
      colorClass: ["grey", "green"],
      msType: ["自动", "手动"],
      lightStatusColor: ["valuegrey", "valueyellow"],
      lightStatus: ["关灯中", "亮灯中"],
      tableData: [],
      pageInfo: {
        page: 1,
        pageSize: 10,
        ms: null, //策略
        lamp_group: null, //灯组
        lamp_number: '', //编号
        lamp_name: '',//名称
        ste: ''//状态
      },
      cnt_all: 0,
      dialogVisible: false,
      editType: -1,
      editOne: {
        number: '',
        name: '',
        lamp_type: null,
        light_pole: '',
        gateway: '',
        is_area_strategy: false,
        is_double: 0,
        lamp_ctrl_type: 0,
        sim: '',
        dev_ctrl_version: 0,
        lamp_group: 0,
        stg_id: 0,
        uid: null,
        project: null,
        address: '',
        longitude: null,
        latitude: null,
        is_display: 0
      },
      editOneRule: {
        name: [{ required: true, message: "请输设备名", trigger: "blur" }],
        number: [{ required: true, message: "请选择协议", trigger: "blur" }]
      },
      manualChange: false,
      lightContorl: {
        visible: false,
        open: false, // 右上角窗口是打开还是收起
        title: '',
        openControl: 'open', // 开灯还是关灯
        double_exist: 1, // 1都是单灯, 2都是双灯, 3存在单、双灯
        light: 50,
        light2: 50,
        result: {success: 0, file: 0, filesIds: ''},
        cmdState: 0   // 0.未发送执行  1.已发送命令  2.部分完成  3.已完成 4.失败  5 socket失败
      },
      recoveryVisible: false,
      backRecovery: false,
      recoveryData: {
        lamp_id: null,
        stg_id: 0,
        stg_name: '暂无策略',
        ms: 0,
        lights_status: 0,
        lamp_group: 0,
        group_name: '暂无策略',
        group_stg_id: 0,
        group_stg_name: '',
        group_ms: 0,
        new_stg_id: 0
      },
      recoveryStrategyList: [],
      importFile: {
        visible: false,
        file: '',
        state: 0,
        fileList: []
      },
      reasonData: {
        visible: false,
        heart: ''
      },
      power: {
        visible: false,
        data: [
          {
            id: 1,
            name: '有功功率',
            value: 0,
            unit: 'W'
          },
          {
            id: 2,
            name: '无功功率',
            value: 0,
            unit: 'Var'
          },
          {
            id: 3,
            name: '视在功率',
            value: 0,
            unit: 'VA'
          },
          {
            id: 4,
            name: '功率因数',
            value: 0.96,
            unit: ''
          },
          {
            id: 5,
            name: '频率采集',
            value: '50',
            unit: 'HZ'
          }
        ]
      },
      freq: {
        visible: false,
        levelArr: ['离线', '极弱', '弱', '中', '强', '极强', '未知'],
        data: []
      },
      multipleSelection: [],
      websocketObj: null, // websocket实例对象
      websocket: {
        socketReconnectNum: 0,
        socketReconnectTimer: null, // 计时器对象——重连
        socketReconnectLock: false, // WebSocket重连的锁
        socketLeaveFlag: false, // 离开标记（解决 退出登录再登录 时出现的 多次相同推送 问题，出现的本质是多次建立了WebSocket连接）
        timeout: 5 * 1000,
        timeoutObj: null,
        serverTimeoutObj: null
      }
    };
  },
  async mounted() {
    await this.getTableData(this.pageInfo.page); // 获取路灯列表
    await this.getProtocolList() // 获取协议列表
    await this.getGroupList('search') // 获取分组列表
    await this.getStrategyList('',3) // 获取策略列表
    let cmd = this.$route.params.cmd;
    if(cmd=='insert'){
      this.openEditWin('create')
    }
  },
  destroyed() {
    this.wsclose();
    if(this.websocketObj){
      this.wsclose();
    }
  },
  methods: {
    getProtocolList() { // 获取协议列表
      lightListApi.getLampProtocol().then((res) => {
        if (res.data.code === 1000) {
          this.protocolList = res.data.data;
          if(this.protocolList.length){
            this.pageInfo.lamp_protocol = this.protocolList[0].id
          }
        }
      });
    },
    getStrategyList(mode='', type=1) { // 获取策略列表
      if(mode=='clear'){
        this.editOne.lamp_group = 0
        this.editOne.stg_id = 0
      }
      strategyApi.strategyList({
        is_double: this.editOne.is_double,
        strategy_type: type,
        page: 1,
        pageSize: 200
      }).then((res) => {
        if (res.data.code === 1000) {
          let resData = res.data.data;
          if(type==1){
            this.strategyList = resData.list;
          }else{
            this.areaStrategyList = resData.list;
          }
        }
      })
    },
    getGroupList(type='') { // 获取灯组列表
      let params = {
        is_double: this.editOne.is_double,
        page: 1,
        pageSize: 200,
      }
      if(type=='search'){
        params = {
          page: 1,
          pageSize: 200,
        }
      }
      lightGroupApi.lightGroupList(params).then((res) => {
        if (res.data.code === 1000) {
          let resData = res.data.data;
          if(type=='search'){
            this.groupListSearch = resData.list;
          }else{
            this.groupList = resData.list;
          }
        }
      });
    },
    getTableData(pageIndex) { // 获取路灯列表
      this.pageInfo.page = pageIndex;
      this.loading = true;
      lightListApi.lightList(this.pageInfo).then((res) => {
        if (res.data.code === 1000) {
          this.loading = false;
          let resData = res.data.data;
          this.tableData = resData.list;
          this.pageInfo.page = pageIndex;
          this.cnt_all = parseInt(resData.count);
          if(this.backRecovery&&this.recoveryData.lamp_id){
            let index = this.getArrayIndex(this.tableData, this.recoveryData.lamp_id)
            this.recoveryVisible = true
            this.recoveryData = this.tableData[index]
          }
          this.backRecovery = false
        }
      });
    },
    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getTableData(this.pageInfo.page);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getTableData(this.pageInfo.page);
    },
    
    openEditWin(index) {
      
      if (index === "create") {
        this.editOne = {
          number: '',
          name: '',
          lamp_type: null,
          light_pole: '',
          gateway: '',
          is_area_strategy: false,
          is_double: 0,
          lamp_ctrl_type: 0,
          sim: '',
          dev_ctrl_version: 0,
          lamp_group: 0,
          stg_id: 0,
          uid: null,
          project: null,
          address: '',
          longitude: null,
          latitude: null,
          is_display: 0
        };
        let address = store.state.user.account.address
        if(address){
          this.editOne.address = address
        }
        let lngLat = store.state.user.account.center
        if(lngLat&&lngLat.length){
          this.editOne.longitude = lngLat[0]
          this.editOne.latitude = lngLat[1]
        } 

        this.editType = "create"
      } else {
        
        this.editOne = {
          lamp_id: index.lamp_id,
          lamp_type: index.lamp_type,
          light_pole: index.light_pole,
          is_area_strategy: index.is_area_strategy?true:false,
          is_double: index.is_double,
          lamp_ctrl_type: index.lamp_ctrl_type,
          number: index.number,
          name: index.name,
          sim: index.sim,
          gateway: index.gateway,
          dev_ctrl_version: index.dev_ctrl_version,
          lamp_group: index.lamp_group,
          stg_id: index.stg_id,
          uid: index.uid,
          project: index.project,
          address: index.address,
          longitude: index.longitude,
          latitude: index.latitude,
          is_display: index.is_display
        };
        
        let lng = index.longitude
        let lat = index.latitude
        let lngLat = [lng, lat]
        if(!lng&&!lat){
          lngLat = store.state.user.account.center
          this.editOne.longitude = lngLat[0]
          this.editOne.latitude = lngLat[1]
          
        }
        this.editType = "update"
      }
      
      this.getStrategyList() // 获取策略列表
      this.getGroupList()// 获取策略列表
      this.dialogVisible = true;
    },
     
    createItem() {
      if(!this.editOne.lamp_type) this.$message.error('请选择设备协议！');

      if(!this.editOne.number) return this.$message.error('请输入设备识别号！');

      if (this.editOne.lamp_type == 5 && !this.editOne.light_pole) return this.$message.error('请输入灯头号！');

      if ((this.editOne.lamp_type == 3 || this.editOne.lamp_type == 5) && !this.editOne.gateway) return this.$message.error('请输入网关编号！');

      this.editOne.is_area_strategy?this.editOne.is_area_strategy=1:this.editOne.is_area_strategy=0
      lightListApi.lightAdd(this.editOne).then((res) => {
        if (res.data.code === 1000) { 
          this.$message.success("添加成功");
          this.dialogVisible = false;
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },

    updateItem() {
      if(!this.editOne.lamp_type) this.$message.error('请选择设备协议！');

      if(!this.editOne.number) return this.$message.error('请输入设备识别号！');

      if (this.editOne.lamp_type == 5 && !this.editOne.light_pole) return this.$message.error('请输入灯头号！');

      if ((this.editOne.lamp_type == 3 || this.editOne.lamp_type == 5) && !this.editOne.gateway) return this.$message.error('请输入网关编号！');


      
      this.editOne.is_area_strategy?this.editOne.is_area_strategy=1:this.editOne.is_area_strategy=0
      lightListApi.lightEdit(this.editOne.lamp_id, this.editOne).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success("修改成功");
          this.dialogVisible = false;
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },

    delItem(id) {
      this.$confirm("删除相关路灯后不可恢复，设备上的相关平台信息也将清空，您确定要删除该路灯吗?", "删除路灯", {
        confirmButtonText: "确认删除",
        cancelButtonText: "取消",
        showClose: false
      })
        .then(() => {
          lightListApi.lightDel(id).then((res) => {
            if (res.data.code === 1000) {
              this.$popupMessage({
                type: 'success',
                title: "删除成功"
                // msg: '如果未刷新，请耐心等待5秒，点击刷新列表查看结果'
              })
              this.getTableData(this.pageInfo.page);
            } else {
              this.$popupMessage({
                type: 'error',
                title: "提示",
                msg: res.data.message,
              })
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    recoveryAll(){
      // 恢复策略
      this.$confirm("您确定将您账号下的所有的路灯都恢复自动策略吗?", "恢复策略", {
        confirmButtonText: "确认恢复",
        cancelButtonText: "取消",
        showClose: false
      }).then(() => {
        strategyApi.recoveryAll().then((res) => {
        if (res.data.code === 1000) {
            this.$popupMessage({
              type: 'success',
              title: "恢复成功"
              // msg: '如果未刷新，请耐心等待5秒，点击刷新列表查看结果'
            })
            this.getTableData(this.pageInfo.page);
          } else {
            this.$popupMessage({
              type: 'error',
              title: "提示",
              msg: res.data.message,
            })
          }
        })
      }).catch(() => {
        this.$message({
          type: "info",
          message: "已取消删除",
        });
      });
    },
    recoveryWin(row){
      // 获取策略列表
      strategyApi.strategyList({
        is_double: row.is_double,
        strategy_type: 1,
        page: 1,
        pageSize: 200
      }).then((res) => {
        if (res.data.code === 1000) {
          let resData = res.data.data;
          this.recoveryStrategyList = resData.list;
          this.recoveryData.lamp_id = row.lamp_id
          this.recoveryData.stg_id = row.stg_id
          this.recoveryData.new_stg_id = row.stg_id
          this.recoveryData.ms = row.ms
          this.recoveryData.lights_status = row.lights_status
          this.recoveryData.lamp_group = row.lamp_group
          this.recoveryData.group_name = row.group_name
          this.recoveryData.group_stg_id = row.group_stg_id
          this.recoveryData.group_stg_name = row.group_stg_name
          this.recoveryData.group_ms = row.group_ms
          this.recoveryVisible = true
        }
      })
    },
    setRecoveryStrategy(id){  //还原策略
      let params = {
        id: id,
        stg_id: this.recoveryData.new_stg_id,
        type: 1
      }
      if(this.recoveryData.lamp_group&&this.recoveryData.group_stg_id&&this.recoveryData.group_ms==0){
        params.stg_id = this.recoveryData.group_stg_id
      }
      strategyApi.recoveryStrategy(params).then((res) => {
        if (res.data.code === 1000) {
          this.recoveryVisible =false
          this.$popupMessage({
            type: 'success',
            title: "恢复成功"
            // msg: '如果未刷新，请耐心等待5秒，点击刷新列表查看结果'
          })
          this.getTableData(this.pageInfo.page);
        } else {
          this.$popupMessage({
            type: 'error',
            title: "提示",
            msg: res.data.message,
          })
        }
      })
    },

    headSearch() {
      this.pageInfo.page = 1
      this.pageInfo.pageSize = 10
      this.getTableData(1)
    },
    onInput() {
      this.$forceUpdate();
    },
    contorlType(type) {
      lightListApi.setAutoControl({
        type: type
      }).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success(res.data.message);
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    importLamp() {
      this.importFile = {
        visible: true,
        file: '',
        state: 0,
        fileList: []
      }
    },
    
    importSend() {
      let that = this
      that.importFile.state = 1
      lightListApi.importExcel({
        file: that.importFile.file
      }).then((res) => {
        that.importFile.state = 0
        that.importFile.visible = false
        if (res.data.code === 1000) {
          that.$popupMessage({
            title: "附件上传成功",
            msg: '返回路灯列表，查看新添加的路灯',
            type: 'success'
          })
          
          that.getTableData(that.pageInfo.page);
        } else {
          that.$popupMessage({
            title: "附件上传失败",
            msg: res.data.message,
            type: 'error'
          })
        }
      });
    },
    uploadAction() {
      return process.env.VUE_APP_BASE_API+'/api/public/uploadFile';
    },
    beforeUpload(file){
      let size = file.size
      let typeArr = file.name.split(".")
      let type = typeArr[typeArr.length-1]
      if (type!='xls'&&type!='xlsx') {
        this.importFile.file= ''
        this.importFile.fileList= []
        this.$message.error('只能上传文件格式为*.xls格式文件！');
        return false
      }
      if(size>2097152){
        this.importFile.file= ''
        this.importFile.fileList= []
        this.$message.error('只能上传大小不能超过2M！');
        return false
      }
    },
    handleAvatarSuccess(res, file) {
      // console.log('handleAvatarSuccess')
      // console.log('handleAvatarSuccess', res, file)
      if (res.data.code === 1000) {
        this.$message.success("上传成功");
        this.importFile.file = res.data.data.file_name;
      } else {
        this.importFile.file= ''
        this.importFile.fileList= []
        this.$message.error("错误，" + res.data.message);
      }
    },
    viewReason(last_ping){
      this.reasonData.visible = true
      this.reasonData.last_ping =  this.$commonJs.formatDate(last_ping*1000)
    },
    showPower(id){
      this.power.visible = false
      lightListApi.powerInfo(id).then((res) => {
        if (res.data.code === 1000) {
          this.power.visible = true
          let resData = res.data.data
          this.power.data[0].value = resData.activePower
          this.power.data[1].value = resData.reactivePower
          this.power.data[2].value = resData.inspectingPower
          this.power.data[3].value = resData.powerFactor
          this.power.data[4].value = resData.frequency
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    showFreq(row){
      this.freq.visible = true
      this.freq.data[0] = {
        value: row.value,
        level: this.freq.levelArr[row.level],
        detail: row.detail
      }
    },
    getRowKey (row) {
      return row.lamp_id
    },
    getCoordinate(map) {
      // console.log('getCoordinate_map', map)
      this.editOne.longitude = map.lng
      this.editOne.latitude = map.lat
      if(map.address){
        this.editOne.address = map.address
      }
    },
    handleSelectionChange(val) {
      val = val.map((item) => {
        return{
          ...item,
          flag: null
        }
      })
      this.multipleSelection = val;
    },
    checkNoSelect(row, index) {
      let isChecked = true
      if (!row.ste) {
        isChecked = false
      }
      return isChecked
    },
    lightContorls (open) {
      const noSelection = this.multipleSelection.length < 1;
      if(noSelection) return this.$message.error('请先勾选路灯！');

      let light1Status = 50;
      let light2Status = 50;
      const isLightOn = open === 'open';
      if(!isLightOn) {
          light1Status = 0;
          light2Status = 0;
      } else if (this.multipleSelection.length === 1) {
          light1Status = this.multipleSelection[0].light;
          if(this.multipleSelection[0].is_double) {
              light2Status = this.multipleSelection[0].light2;
          }
      }
      this.lightContorl = {
        visible: true,
        open: false,
        openControl: open,
        title: `您确定让以下设备执行立即${light1Status ? '开灯' : '关灯'}`,
        light: light1Status,
        light2: light2Status,
        double_exist: this.getLightType(),
        result: { success: 0, file: 0, filesIds: '' },
        cmdState: 0   // 0.未发送执行  1.已发送命令  2.部分完成  3.已完成 4.失败  5 socket失败
      }
    },
    getLightType() {
      const isSingleExist = this.selectionIsDoubleExist(this.multipleSelection, 0); // 存在单灯
      const isDoubleExist = this.selectionIsDoubleExist(this.multipleSelection, 1); // 存在双灯

      if (isSingleExist == -1) return 2; // 不存在单灯,都是双灯
      if (isDoubleExist == -1) return 1; // 不存在双灯,都是单灯
      return 3; // 存在单、双灯
    },
    selectionIsDoubleExist(array = [], type = 0){ //判断所选是否存在单双灯
      return array.findIndex((item) => item.is_double === type)
    },
    lightContorlClose(){

      this.lightContorl = {
        visible: false,
        open: false,
        openControl: 'open',
        title: '',
        double_exist: 0,
        light: 0,
        light2: 0,
        result: {success: 0, file: 0, filesIds: ''},
        cmdState: 0   // 0.未发送执行  1.已发送命令  2.部分完成  3.已完成 4.失败  5 socket失败
      },

      this.multipleSelection = []

      this.$refs.table.clearSelection() //清除选中的数据
      this.wsclose();
      this.getTableData(this.pageInfo.page);
    },
    wsclose(){
      if (!this.websocketObj) return;
      this.websocketObj.close()
      this.websocketObj = null

      Object.assign(this.websocket, {
        socketReconnectNum: 0,
        socketReconnectLock: true,
        socketLeaveFlag: true
      });
     
    },
    lightContorlSend(){
      if(this.multipleSelection.length<1) return this.$message.error('请至少选择一个路灯操作！');
      this.createWebSocket();  // 建立WebSocket
    },
    
    controlResultCount(type){
      //type 0 执行失败， 1执行完成
      let arr = this.multipleSelection
      // flag: null 执行中/未开始，0 执行失败， 1执行完成
      return arr.filter(el => el.flag == type).length
    },
    removeControlLamp(index){
      if(this.multipleSelection.length==1){
        return this.$message.error('至少要保留一个设备！')
      }
      this.multipleSelection.splice(index, 1)
      // console.log('this.multipleSelection', this.multipleSelection)
    },
    // 建立webSocket
    createWebSocket(reconnect=0) { // reconnect 是否重连
      let lamp_ids= '';
      let newSelection = [] // 重新下发处理flag

      this.multipleSelection.forEach(selection => {
        if (!reconnect || selection.flag != 1) {
            lamp_ids += selection.lamp_id + ',';
            newSelection.push(selection);
        }
      });
      
      lamp_ids = lamp_ids.slice(0, -1); // 删除最后一个逗号

      this.websocket.socketReconnectLock = false
      this.websocket.socketLeaveFlag = false

      const that = this
      const wsLink = `${process.env.VUE_APP_BASE_WSS}/message?type=2&token=${getToken()}`;
      try {
        that.websocketObj = new WebSocket(wsLink);
        // 连接成功
        that.websocketObj.onopen = function (e) {
          // console.log('WebSocket连接成功', 'Websocket Connection open ...', e);
          let lampCmd = '{"cmd":"message.control","data":{"light":'+that.lightContorl.light+', "light2":'+that.lightContorl.light2+',"control_type": 1,"lamp_ids":"'+lamp_ids+'", "reconnect":'+reconnect+'}}'
          // console.log('WebSocket发送数据','websock.send', lampCmd)
          that.websocketObj.send(lampCmd)
          that.lightContorl.cmdState = 1
          that.multipleSelection = newSelection
          if(reconnect==0){
            for(let i = 0; i < that.multipleSelection.length; i++){
              that.multipleSelection[i].flag = null
            }
          }
          // cmdState: 0   // 0.未发送执行  1.已发送命令  2.部分完成  3.已完成 4.失败 
          that.resetHeart(1); // 心跳检测重置
        };

        // 接收到消息
        that.websocketObj.onmessage = function (e) {
          // console.log('reconnect', reconnect);
          // console.log('onmessage', e);
          if (e.data.indexOf('heartbeat.pong') > -1) {
            // 心跳回复——心跳检测重置
            // 收到心跳检测回复就说明连接正常
            // console.log('WebSocket数据接收，收到心跳检测回复');
            // 心跳检测重置
            that.resetHeart(1);
          } else {
            const resData = JSON.parse(e.data);
            const { cmd, data } = resData;
            // console.log('普通推送——正常处理:', 'cmd', cmd, 'data', data);
            
            if(cmd=='message.control'){
              if(data.lamp_id){
                let index = that.getArrayIndex(that.multipleSelection, data.lamp_id)
                if(index>-1){
                  // flag: null 执行中/未开始，0 执行失败， 1执行完成
                  that.multipleSelection[index].flag = data.flag
                }
              }
            }
            
            if(cmd=='message.complete'){
              // complete  1部分完成 2已完成 3失败
              that.lightContorl.result = ''
              // <!-- lightContorl.cmdState:  0.未发送执行  1.已发送命令  2.部分完成  3.已完成 4.失败  -->
              if(data.complete==1){ 
                for(let i = 0; i < that.multipleSelection.length; i++){
                  // flag: null 执行中/未开始，0 执行失败， 1执行完成
                  if(that.multipleSelection[i].flag==null){
                    that.multipleSelection[i].flag = 0
                  }
                }
                that.lightContorl.cmdState = 2
              } else if(data.complete==2){
                that.lightContorl.cmdState = 3 
              } else if(data.complete==3){
                for(let i = 0; i < that.multipleSelection.length; i++){
                  that.multipleSelection[i].flag = 0
                }
                that.lightContorl.cmdState = 4
              }
              that.wsclose();
            }
          }
        };

        // 向后端发送数据的回调
        that.websocketObj.onsend = function (e) {
          // console.log('WebSocket发送信息给后端', 'Websocket onsend...', e);
        },

        // 连接失败事件
        that.websocketObj.onerror = function (e) {
          // console.log('WebSocket连接发生错误', 'Websocket error ...', e);
          that.socketReconnect();
        };

        // 链接关闭的回调方法
        that.websocketObj.onclose = function (e) {
          // console.log('WebSocket连接已关闭', 'Websocket Connection closed.', e);
          // 心跳检测重置
          that.resetHeart(0);
          if (!that.websocket.socketLeaveFlag) {
            // 没有离开——重连
            // console.log('WebSocket关闭，用户未离开——重连');
            // websocket重连
            that.socketReconnect();
          }
        };

        // 监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server端会抛异常。
        window.onbeforeunload = () => {
          that.wsclose();
        };
      } catch (e) {
        // console.log('WebSocket连接不上', e);
        // websocket重连
        that.socketReconnect();
      }
    },

    // websocket重连
    socketReconnect() {
      if(this.websocket.socketReconnectNum>3){
        this.$message.error('websocket连接失败，请稍后再试')
        this.wsclose();
        this.lightContorl.cmdState = 4
        return
      }
      this.websocket.socketReconnectNum++
      if (this.websocket.socketReconnectLock) {
        return;
      }
      this.websocket.socketReconnectLock = true
      this.websocket.socketReconnectTimer && clearTimeout(this.websocket.socketReconnectTimer)
      this.websocket.socketReconnectTimer = setTimeout(() => {
        // console.log('WebSocket:重连中...')
        this.websocket.socketReconnectLock = false
        // websocket启动
        this.createWebSocket(1)
      }, 1000)
    },

    // 重置心跳
    resetHeart(type=0) {
      // 清除时间
      clearTimeout(this.websocket.timeoutObj)
      clearTimeout(this.websocket.serverTimeoutObj)
      if (type) {
        // 重启心跳
        this.startHeart()
      }
    },

    // 开启心跳
    startHeart() {
      // console.log('准备开启心跳！');
      let that = this
      that.websocket.timeoutObj && clearTimeout(that.websocket.timeoutObj);
      that.websocket.serverTimeoutObj && clearTimeout(that.websocket.serverTimeoutObj);
      that.websocket.timeoutObj = setTimeout(() => {
        // 这里向后端发送一个心跳检测，后端收到后，会返回一个心跳回复
        if (that.websocketObj.readyState === 1) {
          // 如果连接正常
          that.websocketObj.send('{"cmd":"heartbeat.ping","data":{}}');
          // console.log('5秒后发送的心跳检测', '{"cmd":"heartbeat.ping","data":{}}');
        } else {
          // 否则重连
          that.socketReconnect();
        }
        that.websocket.serverTimeoutObj = setTimeout(() => {
          // 如果超过一定时间还没重置计时器，说明websocket与后端断开了
          // 关闭WebSocket
          that.websocketObj.close();
          // console.log('连续10秒未收到心跳检测回复,关闭websocket');

        }, that.websocket.timeout);
      }, that.websocket.timeout);
    },

    // 查找数组序号
    getArrayIndex(arr, str) {
      let i = arr.length
      while (i--) {
        if (arr[i].lamp_id === str) {
          return i
        }
      }
      return -1
    },
    golampGroup(){
      this.$router.push({
        name: 'lampGroup',
        path:"/light/lampGroup"
      })
    },
    goStrategy(stg_id){
      if(stg_id){
        this.$router.push({
          name: 'strategys',
          path:"/light/strategys",
          params:{stgId: stg_id}
        })
      }else{
        this.$router.push({
          name: 'strategys',
          path:"/light/strategys"
        })
      }
    }
  }
};
</script>
<style lang='less' scoped>
.lightList-content {
  width: 100%;
  .map-container {
    width: 100%;
    height: 292px;
    /* margin-bottom: 20px; */
  }
  .power-more{
    width: 22px;
    height:22px;
    background-image: url(../../../assets/images/power-more.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    cursor: pointer;
    &:hover{
      background-image: url(../../../assets/images/power-more_hover.png);
    }
  }
  .icon-error {
    background: url(/static/images/icons/error.png);
    display: inline-block;
    width: 20px;
    height: 20px;
    background-size: cover;
  }
  .box_control {
    width: 600px !important;
    height: auto !important;
    margin-top: -200px !important;
    margin-left: -300px !important;
    .box_body {
      padding-bottom: 25px;
    }
  }
  .box_control_bg{
    transition: all 0.5s;
    &.pack-up{
      width:0;
      height:0;
      overflow: hidden;
    }
  }

  .lamp-control{
    width: 860px !important;
    height: auto !important;
    top:50% !important;
    margin-top: 0 !important;
    transform: translateY(-50%);
    margin-left: -430px !important;
    color: #333 !important;
    transition: all 0.3s;
    opacity: 1;
    .box_body {
      padding:60px;
      transition: all 1s;
      .box_con{
        padding-bottom: 40px;
        padding: relative;
        display: block;
        box-sizing: border-box;
        width:740px;
        // height:490px;
        .box_title{
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 10px 10px 20px;
          color:#1d2129;
          font-size: 24px;
          font-weight: 600;
        }
        .right-close{
          position: absolute;
          color:#898ea1;
          right:30px;
          top:30px;
          font-size: 20px;
          cursor: pointer;
        }
        .lamp-control-tip{
          padding: 10px 0;
          font-size: 14px;
        }
        .lamp-control-list{
          margin: 0  -25px;
          height:260px;
          overflow-y: auto;
          &::before, &::after {
            content: " ";
            display: table;
          }
          &::after {
            clear: both;
          }
          .item-one{
            width:50%;
            float: left;
            box-sizing: border-box;
            padding: 8px 25px;
            .item-one-pad{
              border-radius: 3px;
              border: 1px solid #ff8b23;
              display: flex;
              align-items: center;
              position: relative;
              padding: 8px 15px;
              box-sizing: border-box;
              .item-icon{
                font-size: 25px;
                color: #ff8b23;
                margin-right: 10px;
              }
              .item-title{
                width:200px;
                font-size: 14px;
                color: #111;
                overflow: hidden;
                text-overflow:ellipsis;
                white-space: nowrap;
              }
              .item-close{
                font-size: 21px;
                color: #ff8b23;
                position: absolute;
                right:15px;
                top:50%;
                transform: translate(0,-50%);
                cursor: pointer;
              }

              .item-cmd{
                font-size: 14px;
                position: absolute;
                right:15px;
                top:50%;
                transform: translate(0,-50%);
                cursor: pointer;
              }
            }
          }
        }
        .lamp-control-silder{
          padding:40px 0 10px;
          .silder-title{
            font-size:18px;
            padding-bottom:5px;
          }
          .silder-box{
            display: flex;
            width:100%;
            align-items: center;
            justify-content: space-between;
            .lamp-silder{
              flex:1;
              width:100%;
            }
            .silder-value{
              font-size:18px;
              margin-left: 20px;
            }
          }
        }

        .lamp-tips{
          padding-bottom:  0 15px;
          margin-top: -5px;
          font-size:14px;
          color:#777;
        }

        .box-tips{
          padding: 40px 0 10px;
          font-size:14px;
          line-height: 1.8;
          .tips-icon{
            float: left;
            color:#2d8cf0;
            display: flex;
            align-items: center;
            i{
              font-size: 18px;
              margin-right: 5px;
            }
          }
        }

      }
    }
    &.pack-up{
      opacity: 0;
    }
  }



  .right-control-btn{
    position: fixed;
    right:30px;
    top:64px;
    width:120px;
    height:50px;
    z-index: 999999;
    background-color: #fff;
    box-shadow: 3px 1px 10px rgba(0,0,0,0.1);
    border-radius: 50px;
    color:#2d8cf0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    transition: all 0.3s;
    cursor: pointer;
    opacity: 0;
    .icon{
      color:#ff881e;
      font-size: 28px;
      margin-right: 6px;
    }
    &.pack-up{
      opacity: 1;
    }
  }
  

  .reason-box{
    width:542px !important;
    height:480px !important;
    background:url(../../../assets/images/reason_bg.jpg) center center no-repeat #f0f6fa;
    background-size: 100% 100%;
    .box_con{
      padding: 30px 35px;
      .box_title{
        display: flex;
        height: 60px;
        color:#2d8cf0;
        justify-content: center;
        font-size:28px;
        i{
          font-size:32px;
        }
        span{
          margin-left:10px;
          font-weight:bold;
        }
      }
      .con-text{
        padding:20px 0 10px;
        color:#86909c;
        font-size:14px;
        line-height:1.6;
        .item-title,.item-heart{
          font-size:16px;
          font-weight:bold;
          margin-top:12px;
          height:32px;
          position:relative;
          padding-left:12px;
          display:flex;
          align-items:center;
          color:#1d2129;
          &::before{
            content:'';
            width:6px;
            height:6px;
            background:#2d8cf0;
            border-radius:6px;
            position:absolute;
            left:0;
            top:50%;
            margin-top:-4px;
          }
        }
        .item-heart{
          color:#2d8cf0;
          height:50px;
        }
        .item{
          padding-left:12px;
        }
      }
    }
    .box-footer{
      justify-content:center !important;
      .el-button--medium{
        padding-left:60px;
        padding-right:60px;
      }
    }
  }

  .freq-box{
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    .freq-icon{
      position: relative;
      display: flex;
      align-items: flex-end;
      justify-content: center;
      margin-right: 6px;
      margin-top: -2px;
      span{
        width:2px;
        background-color: #c4c6cb;
        height:20px;
        margin-right:2px;
        &:first-child{
          height:6px;
        }
        &:nth-child(2){
          height:9px;
        }
        &:nth-child(3){
          height:12px;
        }
        &:nth-child(4){
          height:15px;
        }
        &:last-child{
          height:18px;
        }
      }
      &.icon1{
        span{
          &:first-child{
            background-color: #409EFF;
          }
        }
      }
      &.icon2{
        span{
          &:first-child,&:nth-child(2){
            background-color: #409EFF;
          }
        }
      }
      &.icon3{
        span{
          &:first-child,&:nth-child(2),&:nth-child(3){
            background-color: #409EFF;
          }
        }
      }
      &.icon4{
        span{
          &:first-child,&:nth-child(2),&:nth-child(3),&:nth-child(4){
            background-color: #409EFF;
          }
        }
      }
      &.icon5{
        span{
          &:first-child,&:nth-child(2),&:nth-child(3),&:nth-child(4),&:nth-child(5){
            background-color: #409EFF;
          }
        }
      }
    }
    .freq-value{
      // 极弱和弱 红色；中 蓝色；极强，强 绿
      &.value1,&.value2{
        color:rgba(241, 12, 4, 0.856);
      }

      &.value3{
        color:#409EFF;
      }
      &.value4,&.value5{
        color:rgb(103, 194, 58);
      }
    }
  }

  .col-two{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 17px;
    .col-one{
      width:47%;
      .el-select{
        margin-bottom: 18px;
      }
    }
  }
  .import_box{
    padding: 0 30px 30px;
    position:relative;
    .import_tip{
      padding: 23px 35px;
      background:#fff3e9;
      margin-bottom:18px;
      .tip_text{
        line-height:1.6;
      }
      .tip_foot{
        padding-left:22px;
        display:flex;
        margin-top:12px;
        .tip_icon{
          display:flex;
          color:#ff8b23;
          margin-right:12px;
          margin-top:4px;
        }
        .item{
          line-height:1.6;
        }
      }
    }
    .upload-import-box{
      width:100%;
      position:relative;
      height:120px;
      .select-btn{
        position:absolute;
        right:0;
        bottom:0;
        z-index:99;
        margin: 0;
      }
      &.have{
        .select-btn{
          position:absolute;
          right:130px;
          bottom:0;
          z-index:99;
        }
      }
    }
    .cancel-btn{
      position:absolute;
      right:160px;
      bottom:30px;
      z-index:99;
      margin:0;
      &.have{
        right:290px;
      }
    }
    .start-btn{
      position:absolute;
      right:30px;
      bottom:30px;
      z-index:99;
    }
    .demo_xls{
      position:absolute;
      left:30px;
      bottom:30px;
      z-index:99;
      height:40px;
      display:flex;
      align-items:center;
      color:#2d8cf0;
      font-size:18px;
      svg{
        font-size:17px;
      }
      .xls-link{
        color:#2d8cf0;
        font-size:14px;
        margin-left:6px;
        text-decoration: none;
      }
    }
  }
}
</style>

<style lang="less">
.import_box{
  .el-upload-list__item-name{
    color:#1d2129;
    i{font-size: 17px !important;color:#111;}
  }
  
}
.area-input-b{
  margin-bottom: 18px;
}
.lightList-content{
  .form-info{
    padding: 0 22px 0 15px;
    .map-box{
      padding-left: 20px;
    }
    .el-form-item__label{
      width:85px;
      white-space: nowrap;
    }
  }
}

</style>